import { Table } from "antd";
import { useMemo } from "react";

const BudgetReportTable = ({ columns, dataSource }) => {
    const updatedColumns = useMemo(() => {
        const renderValue = (value) => (
            <span style={{ fontSize: "16px", fontWeight: 600 }}>
                {value}
            </span>
        );

        return columns.map((column) => {
            // Don't change Parameter column
            if (column.dataIndex === "label") {
                return column;
            }

            // Quarter grouped columns
            if (column.children) {
                return {
                    ...column,
                    children: column.children.map((child) => ({
                        ...child,
                        render: renderValue,
                    })),
                };
            }

            // TOTAL column
            return {
                ...column,
                render: renderValue,
            };
        });
    }, [columns]);

    return (
        <Table
            className="custom-ant-table"
            columns={updatedColumns}
            dataSource={dataSource}
            bordered
            pagination={false}
            sticky
            tableLayout="fixed"
            scroll={{
                x: "max-content",
                y: 1200,
            }}
        />
    );
};

export default BudgetReportTable;